import pointsStandingsLookup from './pointsStandingsLookup';

type ParamsWithYear = {
  tour: number;
  division: number;
  class: string;
  year?: number;
};

export default function pointsStandingsParams (type: number, year: number = null): string {
  const params: ParamsWithYear = pointsStandingsLookup(type);
  params.year = year ? year : new Date().getFullYear();
  return Object.keys(params).map((key) => `${key}=${params[key]}`).join('&');
};
